import { render, staticRenderFns } from "./Cliente_nuevo.vue?vue&type=template&id=7be2f6a3&scoped=true"
import script from "./Cliente_nuevo.vue?vue&type=script&lang=js"
export * from "./Cliente_nuevo.vue?vue&type=script&lang=js"
import style0 from "./Cliente_nuevo.vue?vue&type=style&index=0&id=7be2f6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2f6a3",
  null
  
)

export default component.exports